import SpringConfigs from '../swarm/spring-configs';

export const isRtl = SpringConfigs.IS_RTL;
